import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer, ListContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';

import { InputFields, LazyCallBack } from '~/src/components/LazyCallBack/styled';

export const NonStaticContainerWithRotation = styled(NonStaticContainer)<{
    $rotate: number,
}>`
    rotate: ${({ $rotate }) => $rotate}deg; 
`;

export const SpeedLineContainer = styled.section`
    padding: 114px 0 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background: url(/static/images/lk/lk-background.png) no-repeat;
    background-size: cover;
    top: 0;
    position: relative;
    height: 100vh;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 54px 0 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 32px 0 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 39px 0 0;
    }

    ${ListContainer} > h1,
    ${ListContainer} > h2 {
        max-width: 670px;
        text-align: center;
        margin: auto;
    
        @media (max-width: ${wideBreakpoints.laptop}) {
            max-width: 468px;
        }
    
        @media (max-width: ${wideBreakpoints.mobile}) {
            max-width: 255px;
        }
    }

    & > ${IndentContainer} {
        max-width: 500px;
    }

    ${LazyCallBack} {
        width: 100%;
        max-width: 400px;

        @media (max-width: ${wideBreakpoints.mobile}) {
            max-width: 350px;
        }

        ${InputFields} {
            flex-direction: column;
        }
    }
`;
